import apiClient from '@/services/axios'

export async function del(guestId, venueId, consent) {
  var response = await apiClient.delete(process.env.VUE_APP_CRM_API_BASE_URL + `/GuestProfiles/venue/consent?guestId=${guestId}&venueId=${venueId}&consent=${consent}`)
  if (response) {
    return response.data
  }

  throw new Error('Unable to delete venue consent')
}

// https://rekom-crm-api-prod.azurewebsites.net/api/GuestProfiles/venue/consent?guestId=baddfd85-f799-4689-ba7e-ee851eb1fcd9&venueId=89ba9ba5-eabb-43c2-8e35-839652988ee4&consent=PersonalData

// https://rekom-crm-api-prod.azurewebsites.net/api/GuestProfiles/venue/consent?guestId=baddfd85-f799-4689-ba7e-ee851eb1fcd9&venueId=89ba9ba5-eabb-43c2-8e35-839652988ee4&consent=PersonalData%27